import { useEffect, useState, useCallback } from 'react';

const STORAGE_KEY = 'mf_site_theme';

function readInitialTheme() {
  if (typeof window === 'undefined') return 'light';
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'dark' || stored === 'light') return stored;
  // Respeitar preferência do sistema na primeira visita
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }
  return 'light';
}

/**
 * Hook de tema light/dark do site público MF Real Estate.
 * Persiste em localStorage('mf_site_theme') e aplica via data-theme no <html>.
 * Não afeta o admin V2 (que usa key separada 'mf_admin_v2_theme').
 */
export default function useDarkMode() {
  const [mode, setMode] = useState(readInitialTheme);

  // Aplica no <html> e persiste
  useEffect(() => {
    if (typeof document === 'undefined') return;
    if (mode === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
    try { localStorage.setItem(STORAGE_KEY, mode); } catch {}
  }, [mode]);

  const toggle = useCallback(() => {
    setMode(m => (m === 'dark' ? 'light' : 'dark'));
  }, []);

  return { mode, toggle, isDark: mode === 'dark' };
}
